const fromCancelAppointmentQueryToAppointment = (data)=>{
    if (!data) {
        return null;
    }
    const { status , id , invitee , appointmentType , startTime , endTime , store , storeInfo , child , preferredChannelOfCommunication ,  } = data;
    var _lastName, _lastName1;
    return {
        status,
        id,
        endTime: new Date(endTime),
        startTime: new Date(startTime),
        invitee: invitee ? {
            firstName: invitee.firstName,
            lastName: (_lastName = invitee.lastName) !== null && _lastName !== void 0 ? _lastName : undefined
        } : undefined,
        appointmentType: appointmentType ? {
            id: appointmentType.id,
            name: appointmentType.name,
            ageGroup: appointmentType.ageGroup,
            description: appointmentType.description,
            duration: {
                amount: appointmentType.duration.amount,
                unit: appointmentType.duration.unit
            },
            isVisibleToCustomers: appointmentType.visibleToCustomers
        } : undefined,
        store: store ? {
            code: store.code
        } : undefined,
        storeInfo: storeInfo ? {
            globalStoreId: storeInfo.globalStoreId
        } : undefined,
        child: child ? {
            firstName: child.firstName,
            lastName: (_lastName1 = child.lastName) !== null && _lastName1 !== void 0 ? _lastName1 : undefined
        } : undefined,
        preferredChannelOfCommunication: preferredChannelOfCommunication !== null && preferredChannelOfCommunication !== void 0 ? preferredChannelOfCommunication : undefined
    };
};

export { fromCancelAppointmentQueryToAppointment };
//# sourceMappingURL=fromCancelAppointmentQueryToAppointment.js.map
